module.exports = __webpack_public_path__ + "img/service1.18102e2f.svg";